export const trackClick = (eventName: string, eventProperties: any) => {
  window.analytics.track(eventName, eventProperties)
}
